import Vue from 'vue'
import {ptracGetEntities} from 'src/utilities/ptracApi'
import {make} from 'vuex-pathify'
import {
  byId,
  crudifyMutations,
  hydrateEdit,
  resetResults,
  resetState,
  savePayload,
  updateResult
} from 'src/utilities/vuex2'
import {OK} from 'http-status-codes'

const initialState = {
  edit: {
    id: null,
    name: '',
    projectType: null,
    createdAt: null,
    createdBy: null,
    updatedAt: null,
    updatedBy: null
  },
  query: {
    name: null,
  },
  results: []
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)
getters.byId = byId
getters.savePayload = savePayload
getters.isDuplicateTag = (state) => {
  for (const result of state.results) {
    if (result.name === state.edit.name.trim() && result.projectType === state.edit.projectType) {
      return true
    }
  }
  return false
}

const mutations = make.mutations(state)
mutations.reset = resetState
mutations.resetResults = resetResults
mutations.updateResult = updateResult
mutations.resetEdit = (state) => {
  state.edit = {
    id: null,
    name: null,
    projectType: null,
    createdAt: null,
    createdBy: null,
    updatedAt: null,
    updatedBy: null
  }
}
mutations.hydrateEdit = hydrateEdit
crudifyMutations(mutations)

mutations.resetEdit = (state) => {
  state.edit = JSON.parse(JSON.stringify(initialState.edit))
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchAll({ state }) {
      const response = await ptracGetEntities('tags/search/findAllByOrderByNameAsc')
      if (OK === response.status) {
        state.results = response.data
      }
    }
  }
}
